import NotesTabContainer from './NotesTabContainer';

export default NotesTabContainer;
